<div class="isometric">
  <div class="box"></div>
  <div class="box"></div>
  <div class="box"></div>
  <div class="box"></div>
</div>
<h2>Cargando<span>...</span></h2>
